import { render, staticRenderFns } from "./RecapPetugas.vue?vue&type=template&id=4e052154&"
import script from "./RecapPetugas.vue?vue&type=script&lang=js&"
export * from "./RecapPetugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports